

import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaFilter } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { CSVLink } from 'react-csv';

import ApiUiController from '../../controller/ApiUiController';
import FieldController from '../../controller/FieldController';
import ReportAPI from '../../api/ReportAPI';
import FilterDate from '../filter/FilterDate';
import FilterPannel from '../filter/FilterPannel';
import withRouter from '../../util/WithRouter';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import ReportWidget from './ReportWidget';
import ViewController from "../../controller/ViewController";

class ReportSelectToSelect extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.export = [];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [user.user_id, ...user.child];

    this.report = props.report;
    this.headers = [];
    this.rows = [];
    this.data = null;
    this.model = {};

    const model = this.models[this.report.model];
    this.model = model;
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);

    const filters = [];
    if (this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for (let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i] });
        filters[i].value = FilterDate.getValue(filters[i].value ? filters[i].value : filters[i].condition);
      }
    }
    this.filters = ViewController.filters(filters, [], this.Restrict);
    this.state = { isFilterOpen: true, inApiCall: false };
  }

  componentDidMount() {
    this.loadReports();
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onData = res => {
    new Promise(resolve => {
      resolve(this.calculte(res));
    }).then(data => {
      this.res = res;
      this.data = data;
      this.setState({ ...this.state, inApiCall: false });
    });
  };

  onFilterChange = filters => {
    this.setState({ ...this.state, inApiCall: true });
    this.filters = filters;
    this.loadReports();
  };

  loadReports = () => {
    const restrict = this.filters.find(filter => filter.field === 'responsible_person');
    if (this.Restrict && !restrict) {
      this.filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'in', value: `${Const.Opt}${this.children.join(Const.Opt)}${Const.Opt}`
      });
    }

    if (this.props.saveFilter) {
      this.props.saveFilter(this.filters);
    }
    ReportAPI.data(this.report.id, this.filters, this.onData, this.onFail);
  };

  toggleFilter = () => this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });

  calculte = res => {
    const model = this.models[this.report.model];
    if (!model) return { headers: [], body: [] };

    const x = this.report.x;
    const y = this.report.y;
    const z = this.report.sum;

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [user.user_id, ...user.child];
    let xOptions = FieldController.getOptions(model.fields[x], undefined, true);
    if (this.restrict && model.fields[x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = this.filters.find(filter => filter.field === model.fields[x].field_key);
    if (filter) {
      xOptions = xOptions.filter(opt => filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    }
    this.xOptions = xOptions;

    const headers = xOptions.map(option => option.label);
    headers.push('Total');

    let yOptions = FieldController.getOptions(model.fields[y], undefined, true);
    if (this.restrict && model.fields[y].field_type.includes('~user')) {
      yOptions = yOptions.filter(opt => children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    filter = this.filters.find(filter => filter.field === model.fields[y].field_key);
    if (filter) yOptions = yOptions.filter(opt => filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    this.yOptions = yOptions;

    const rows = yOptions.map(option => option.label);

    const body = [];
    const mainTotal = ['Total'];
    for (let j = 0; j < headers.length - 1; j++) {
      mainTotal.push(0);
    }
    mainTotal.push(0);

    for (let i = 0; i < rows.length; i++) {
      const yVal = yOptions[i].value;
      let row = [rows[i]];
      let total = 0;
      for (let j = 0; j < headers.length - 1; j++) {
        const xVal = xOptions[j].value;
        let xType = model.fields[x].field_type;
        xType = xType.includes(Const.MultiSelect);
        let yType = model.fields[y].field_type;
        yType = yType.includes(Const.MultiSelect);
        let tmp = [];
        if (!xType && !yType) {
          tmp = res.filter(item => item[x] === xVal && item[y] === yVal);
        } else if (xType && !yType) {
          tmp = res.filter(item => item[x] && item[x].includes(`~${xVal}~`) && item[y] === yVal);
        } else if (!xType && yType) {
          tmp = res.filter(item => item[x] === xVal && item[y] && item[y].includes(`~${yVal}~`));
        } else {
          tmp = res.filter(itm => itm[x] && itm[x].includes(`~${xVal}~`) && itm[y] && itm[y].includes(`~${yVal}~`));
        }
        let count = 0;
        if (tmp.length > 0) {
          if (z && z.includes(Const.Opt)) {
            for (let k = 0; k < tmp.length; k++) {
              if (y.includes(Const.Opt)) {
                const items = tmp[k][y].length > 2 ? tmp[k][y].substring(1, tmp[k][y].length - 1).split(Const.Opt) : [];
                const itemCounts = tmp[k].sum.length > 2 ? tmp[k].sum.substring(1, tmp[k].sum.length - 1).split(Const.Opt) : [];
                for (let l = 0; l < items.length; l++) {
                  if (parseInt(items[l]) === yVal) {
                    count += parseInt(itemCounts[l]);
                  }
                }
              } else {
                for (let k = 0; k < tmp.length; k++) {
                  count += parseFloat(tmp[k].sum.substring(1, tmp[k].sum.length - 1));
                }
              }
            }
          } else {
            for (let k = 0; k < tmp.length; k++) {
              count += tmp[k].sum;
            }
          }
        }
        row.push(count);
        total += count;
        mainTotal[j + 1] += count;
      }
      row.push(total);
      body.push(row);
      mainTotal[mainTotal.length - 1] += total;
    }
    body.push(mainTotal);
    this.export = [[this.model.fields[this.report.y].label_name, ...headers], ...body];
    return { headers, body };
  };

  loadView = (i, j) => {
    if (j === 0) return;
    const filters = [...this.filters];

    let type = this.models[this.report.model].fields[this.report.y].field_type;
    if (type === Const.Complete) {
      if (i - 1 < this.yOptions.length) {
        filters.push({
          field: this.report.y, type, condition: this.yOptions[i - 1].value === Const.True
            ? 'not-in' : 'in'
        });
      }
    } else {
      let yValue;
      if (i < this.yOptions.length) {
        yValue = `${Const.Opt}${this.yOptions[i].value}${Const.Opt}`;
      } else {
        yValue = `${Const.Opt}${this.yOptions.map(opt => opt.value).join(Const.Opt)}${Const.Opt}`;
      }
      filters.push({ field: this.report.y, type, condition: 'in', value: yValue });
    }

    type = this.models[this.report.model].fields[this.report.x].field_type;
    if (type === Const.Complete) {
      if (j - 1 < this.xOptions.length) {
        filters.push({
          field: this.report.x, type, condition: this.xOptions[j - 1].value === Const.True
            ? 'not-in' : 'in'
        });
      }
    } else {
      j--;
      let xValue;
      if (j < this.xOptions.length) {
        xValue = `${Const.Opt}${this.xOptions[j].value}${Const.Opt}`;
      } else {
        xValue = `${Const.Opt}${this.xOptions.map(opt => opt.value).join(Const.Opt)}${Const.Opt}`;
      }
      filters.push({ field: this.report.x, type, condition: 'in', value: xValue });
    }


    const model = this.report.model !== 'sales_order' ? this.report.model : 'sales-order';
    this.props.navigate(`/${model}?filters=${JSON.stringify(filters)}`);
  };

  render() {
    const headers = this.data && this.data.headers ? this.data.headers.map((header, i) =>
      <th key={`table_header_${i + 1}`}>{header}</th>) : null;
    const body = this.data && this.data.body ?
      this.data.body.map((row, i) =>
        <tr key={`body_${i}`}>{row.map((item, j) =>
          <td key={`body_${i}_${j}`} onClick={() => this.loadView(i, j)}>{item}</td>)}</tr>)
      : null;

    let table = <Table striped bordered hover>
      <thead>
        <tr>
          <th key="table_header_0">
            {this.model.fields[this.report.y].label_name}
          </th>
          {headers}
        </tr>
      </thead>
      <tbody className="listlead">{body}</tbody>
    </Table>;

    if (this.props.dashbaord) {
      return (
        <div className="col-md-6">
          <div className="dashboard-report-titles mt-3">{this.report.name}</div>
          <div> <ApiUiController inApiCall={this.state.inApiCall}> {table} </ApiUiController> </div>
        </div>
      );
    }
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6">
                  <h4>{this.report.name}</h4></div>
                <div className="col-md-6">
                  <CSVLink data={this.export}>
                    <Button className="buttons btn-success exportbtn">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>

            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button" onClick={this.toggleFilter}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  {this.res ?
                    <ReportWidget view_type={this.report.view_type} type={this.report.type}
                      model={this.report.model} x={this.report.x} y={this.report.y}
                      z={this.report.sum} filters={this.filters} data={this.res}
                      name={this.report.name} />
                    : null
                  }
                  <div className="col-md-12"> {table} </div>
                </div>
                <FilterPannel filters={this.filters} fields={this.model.fields}
                  onFilterChange={this.onFilterChange} isFilterOpen={this.state.isFilterOpen}
                  restrict={this.Restrict} />
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportSelectToSelect);